import React from "react";
import { formatPrice } from "theme/components/atoms/Typography/Price";
import { defineMessages, injectIntl } from "react-intl";
import FormItem from "theme/components/molecules/Form/Item";
import RadioGroup, {
  Radio,
} from "theme/components/atoms/Form/Input/RadioGroup";
import NumberInput from "theme/components/atoms/Form/Input/NumberInput";

const messages = defineMessages({
  radioNoneLabel: {
    id: "components.organisms.Configurator.BundleOption.radioNoneLabel",
    defaultMessage: "None",
  },
  radioValueLabel: {
    id: "components.organisms.Configurator.BundleOption.radioValueLabel",
    defaultMessage: "{label} (+{price})",
  },
  radioQuantityLabel: {
    id: "components.organisms.Configurator.BundleOption.radioQuantityLabel",
    defaultMessage: "Quantity",
  },
});

const BundleOptionRadio = ({ intl, option, selectedBundledProduct }) => {
  return (
    <div className="bundle-option">
      <div className="bundle-option__option">
        <FormItem label={option.label}>
          <RadioGroup
            required={option.required}
            id={`${option.id}.values[0]`}
            name={`${option.id}.values[0]`}
            value={selectedBundledProduct?.value}
            values={option.values.map(({ value }) => value)}
            showNoneRadio={!option.required}
            renderRadio={(props) => {
              const value = option.values.find(
                ({ value }) => value === props.value
              );
              const label = value
                ? intl.formatMessage(messages.radioValueLabel, {
                    label: `${value.label}`,
                    price: formatPrice(
                      intl,
                      value.prices.finalPrice.priceInclTax
                    ),
                  })
                : intl.formatMessage(messages.radioNoneLabel);
              return <Radio {...props} label={label} />;
            }}
          />
        </FormItem>
      </div>
      <div className="bundle-option__quantity">
        <FormItem label={intl.formatMessage(messages.radioQuantityLabel)}>
          <NumberInput
            appearance="start"
            name={`${option.id}.quantity`}
            id={`${option.id}.quantity`}
            disabled={!selectedBundledProduct?.userDefinedQuantity}
            value={
              selectedBundledProduct
                ? selectedBundledProduct.defaultQuantity
                : 0
            }
          />
        </FormItem>
      </div>
    </div>
  );
};
export default injectIntl(BundleOptionRadio);
